import React from 'react';
import { boardAppointments, academicCredentials, civicEngagement } from '../../data/board';
import { SectionHeading } from '../SectionHeading';
const groups = [{
  label: 'Board Appointments',
  items: boardAppointments
}, {
  label: 'Academic Credentials',
  items: academicCredentials
}, {
  label: 'Civic Engagement',
  items: civicEngagement
}];
export function BoardCredentials() {
  return <section id="board" className="w-full bg-white py-20 lg:py-28" data-id="element-103" data-mp="2majrmutjardk">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-104" data-mp="2mdfpyk9ani2j">
        <SectionHeading title="Board Experience, Education & Civic Leadership" intro="Formal appointments, qualifications, and service outside the operating role." data-id="element-105" data-mp="2raz31gu99osw" />

        <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-12" data-id="element-106" data-mp="2hcrpz9337qw6">
          {groups.map(group => <div key={group.label} className="border-t border-navy-900 pt-7" data-id="element-107" data-mp="bjtefgf6i0yd">
              <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-gold-600" data-id="element-108" data-mp="fjbyyb338a0o">
                {group.label}
              </h3>
              <ul className="mt-6 divide-y divide-line" data-id="element-109" data-mp="1rpvrp3erqpp1">
                {group.items.map(item => <li key={item} className="py-4 text-[15px] leading-relaxed text-ink first:pt-0 last:pb-0" data-id="element-110" data-mp="21i1s91j36ffu">
                    {item}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}